/*
 * @Autor: Nehc
 * @Date: 2020-12-05 11:13:28
 * @LastEditors: Nehc
 * @LastEditTime: 2020-12-05 14:06:06
 */
import Rules from './promotion_rule.vue';

export default Rules;
